import { NavGroupKey } from '../../utils/routing/location-constants';

export const NAV_ITEM_HEIGHT = 38;
export const NAV_HOVER_OPEN_DELAY_MS = 300;
export const NAV_HOVER_CLICK_GRACE_MS = 700;

// Popper offset constants — skidding values mirror the removed CSS translates
export const POPPER_HEADER_HEIGHT = 68;
export const POPPER_NAV_GAP = 9;
export const POPPER_TERTIARY_DISTANCE = 3;

export const NAV_POPOVER_CONFIG = {
  modifiers: [
    { name: 'offset', options: { offset: [-POPPER_HEADER_HEIGHT, POPPER_NAV_GAP] } },
    { name: 'preventOverflow', options: { altAxis: true } }
  ]
};

export const NAV_TERTIARY_POPOVER_CONFIG = {
  modifiers: [
    { name: 'offset', options: { offset: [-POPPER_HEADER_HEIGHT, POPPER_TERTIARY_DISTANCE] } },
    { name: 'preventOverflow', options: { altAxis: true } }
  ]
};

export const enum NavMenuKey {
  CLIENT_SELECTOR = 'client_selector',
  PAGE_SEARCH = 'page_search'
}
export type NavMenuType = `${NavGroupKey}` | `${NavMenuKey}`;
